module.exports = __webpack_public_path__ + "static/media/amazon-import.560aa24c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/amazon-import.gif
// module id = ./src/assets/Home/amazon-import.gif
// module chunks = 0